/* global jQuery */

import Typed from 'typed.js';

( function( $ ) {

    var options = {
      strings: ["Serve the Nation ^2000", "Fortify Defense ^2000", "Reinvent the Battlespace ^2000"],
      typeSpeed: 50,
      backSpeed: 20,
      loop: true,
      loopCount: Infinity,
      showCursor: false,
      onStringTyped: function(pos, self) {setTimeout(function() {$('#hero-carousel').carousel('next')}, 1000)}
    }
    
    const selector = '.c-typed-header';
    let typed = null;

    if ( $( selector ).length ) {
      typed = new Typed(selector, options);
    }

} )( jQuery );



// WEBPACK FOOTER //
// ./src/js/inc/typed.js